import BaseModal from '../Shared/BaseModal.js';
import { useState, useEffect } from "react";
import { RoundedButton, ButtonCorner } from '../Buttons/RoundedButton.js';
import {
    Form,
    Input,
    Label,
    Container,
    Row,
    Col,
    Spinner,
    FormFeedback
} from "reactstrap";
import { Color } from '../../constants/colors';

const ChangeLicenseCountModal = ({ isOpen, isLoading, handleClose, submitHandler, currentLicenseCount, newLicenseCount, setNewLicenseCount }) => {
    const nonBreakingSpace = "\u00A0";
    const [isValid, setIsValid] = useState(true);

    const valueChanged = (event) => {
        const value = parseInt(event.target.value);
        setNewLicenseCount(value);
    }

    useEffect(() => {
        if (newLicenseCount >= 0 && newLicenseCount <= 99) {
            setIsValid(true);
        }
        else {
            setIsValid(false);
        }
    }, [newLicenseCount]);

    const headerContent =
        <Container>
            <Row>
                <Col className="d-flex centered-flex-content">
                    <h5 className="modal-title text-black">Change License Count</h5>
                </Col>
            </Row>

        </Container>;

    const bodyContent =
        <>
            <Form >
                <Container>
                    {isLoading &&
                        <Spinner className="centered-loader" />
                    }
                    {!isLoading &&
                        <>
                            <Row>{nonBreakingSpace}</Row>
                            <Row>
                                <span className="h4">Each license allows you to install and use the app on one device.</span>
                            </Row>
                            <Row>{nonBreakingSpace}</Row>
                            <Row><small><span className="required-indicator">*</span>Newly added licenses will be prorated until the next billing cycle.</small></Row>
                            <Row><small><span className="required-indicator">*</span>Removed licenses will be canceled at the start of the next billing cycle.</small></Row>
                            <Row>{nonBreakingSpace}</Row>
                            <Row className="border-solid-2px border-color-darkGreen rounded" >
                                <Col className="d-flex py-4 border-right-solid-2px border-color-darkGreen background-color-lightGray justify-content-center align-items-center">
                                    <Label className="font-size-16px">
                                        Current License Count: <span className="text-green font-size-20px font-weight-bolder">{currentLicenseCount}</span>
                                    </Label>
                                </Col>
                                <Col className="d-flex align-items-center">
                                    <Col xs="7" className="justify-content-end">
                                        <Label className="font-size-16px" for="currentLicenseCount">
                                            New License Count:
                                        </Label>
                                    </Col>
                                    <Col xs="5" className="justify-content-start">
                                        <Input
                                            min="0"
                                            max="99"
                                            valid={isValid}
                                            invalid={!isValid}
                                            className="font-size-20px text-darkBlue font-weight-bold"
                                            onChange={valueChanged}
                                            id="currentLicenseCount"
                                            type="number"
                                            defaultValue={newLicenseCount}
                                        />
                                        {
                                            <FormFeedback tooltip>
                                                Please enter a value between 0 and 99.
                                            </FormFeedback >
                                        }
                                    </Col>

                                </Col>


                            </Row>

                            <Row>{nonBreakingSpace}</Row>
                            <Row>{nonBreakingSpace}</Row>
                            <Row className="d-flex justify-content-end">
                                <RoundedButton
                                    hoverColor={Color.DeleteRed}
                                    hoverTextColor={Color.White}
                                    hoverOutlineColor={Color.DeleteRed}
                                    textColor={Color.Red}
                                    buttonColor={Color.White}
                                    className="mr-3"
                                    outlineColor={Color.DeleteRed}
                                    cornerRadius={ButtonCorner.SevenPX}
                                    clickHandler={handleClose}
                                    type="button"
                                    width="100px"
                                    text="Cancel" />
                                <RoundedButton
                                    hoverColor={Color.Black}
                                    hoverTextColor={Color.White}
                                    hoverOutlineColor={Color.Black}
                                    textColor={Color.White}
                                    buttonColor={Color.DarkBlue}
                                    outlineColor={Color.DarkBlue}
                                    cornerRadius={ButtonCorner.SevenPX}
                                    clickHandler={submitHandler}
                                    type="button"
                                    width="150px"
                                    text="Confirm Changes"
                                    disabled={!isValid}
                                />
                            </Row>
                        </>
                    }
                </Container>
            </Form>
        </>
    return (
        <>
            <BaseModal
                headerClassName="background-color-lightGray"
                isOpen={isOpen}
                toggle={handleClose}
                headerContent={headerContent}
                bodyContent={bodyContent}
                size="lg"
            />
        </>

    );
}

export default ChangeLicenseCountModal;